import { bl_sfa_qualification_criteria_link_RowClass as bl_sfa_qualification_criteria_link_RowClass } from "../../dbschema/bl_sfa_qualification_criteria_link.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaQualificationCriteriaLinkContainerModel extends BaseContainerModel {
	bl_sfa_qualification_criteria_link: bl_sfa_qualification_criteria_link_RowClass =
		new bl_sfa_qualification_criteria_link_RowClass();
}
